//i18n-setup.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
//import messages from '@/lang/en';
import axios, { AxiosRequestConfig } from 'axios';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    // locale: 'en', // set locale
    // fallbackLocale: 'en',
});

const loadedLanguages = ['en']; // our default language that is preloaded

function setI18nLanguage(lang: string) {
    i18n.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html')?.setAttribute('lang', lang);
    return lang;
}

export function loadLanguageAsync(lang: string) {
    // If the same language
    if (i18n.locale === lang) {
        return Promise.resolve(setI18nLanguage(lang));
    } else {
        /* webpackChunkName: "lang-[request]" */ //`@/lang/${lang}`
        return axios
            .get(`/cm/gres/lang/${lang}.json`)
            .then((result) => {
                let data = result.data;
                let decodeMessage = Object.create({});
                for (let key in data) {
                    if (typeof key == typeof '') {
                        var value = data[key];
                        if (value) {
                            value = decodeURI(value);
                        }
                        decodeMessage[key] = value;
                    }
                }
                i18n.setLocaleMessage(lang, { message: decodeMessage });
                console.log('i18nMessage', i18n.messages);
                loadedLanguages.push(lang);
                return setI18nLanguage(lang);
            })
            .catch((err) => {
                debugger;
            });
    }

    // // If the language was already loaded
    // if (loadedLanguages.includes(lang)) {
    //     return Promise.resolve(setI18nLanguage(lang));
    // }

    // // // If the language hasn't been loaded yet
    // return import(
    //     /* webpackChunkName: "lang-[request]" */ `@/i18n/messages/${lang}.js`
    // ).then((messages) => {
    //     i18n.setLocaleMessage(lang, messages.default);
    //     loadedLanguages.push(lang);
    //     return setI18nLanguage(lang);
    // });
}

export function createLanguageFiles() {
    return axios.get('/cm/api/system/String/create').then((res) => {
        return res;
    });
}
